"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRE_REGISTRATION_AWARENESS_CHANNELS = exports.AWARENESS_LABELS = exports.REGION_LABELS = void 0;
const marketing_enum_1 = require("../enums/marketing.enum");
exports.REGION_LABELS = {
    [marketing_enum_1.Region.SEOUL]: '서울특별시',
    [marketing_enum_1.Region.GYEONGGI]: '경기도',
    [marketing_enum_1.Region.GANGWON]: '강원도',
    [marketing_enum_1.Region.CHUNGCHEONG_N]: '충청북도',
    [marketing_enum_1.Region.CHUNGCHEONG_S]: '충청남도',
    [marketing_enum_1.Region.GYEONGSANG_N]: '경상북도',
    [marketing_enum_1.Region.GYEONGSANG_S]: '경상남도',
    [marketing_enum_1.Region.JEOLLA_N]: '전라북도',
    [marketing_enum_1.Region.JEOLLA_S]: '전라남도',
    [marketing_enum_1.Region.JEJU]: '제주특별자치도',
    [marketing_enum_1.Region.BUSAN]: '부산광역시',
    [marketing_enum_1.Region.DAEGU]: '대구광역시',
    [marketing_enum_1.Region.ULSAN]: '울산광역시',
    [marketing_enum_1.Region.GWANGJU]: '광주광역시',
    [marketing_enum_1.Region.INCHEON]: '인천광역시',
    [marketing_enum_1.Region.SEJONG]: '세종특별자치시',
    [marketing_enum_1.Region.ETC]: '기타',
};
exports.AWARENESS_LABELS = {
    [marketing_enum_1.AwarenessChannel.PORTAL_SEARCH]: '인터넷 검색',
    [marketing_enum_1.AwarenessChannel.SNS]: 'SNS',
    [marketing_enum_1.AwarenessChannel.OFFLINE_AD]: '포스터/현수막',
    [marketing_enum_1.AwarenessChannel.SMS_EMAIL]: '문자&이메일',
    [marketing_enum_1.AwarenessChannel.COMMUNITY]: '커뮤니티',
    [marketing_enum_1.AwarenessChannel.MASS_MEDIA]: 'TV/라디오',
    [marketing_enum_1.AwarenessChannel.REFERRAL]: '지인 추천',
    [marketing_enum_1.AwarenessChannel.APARTMENT_AD]: '아파트 광고',
    [marketing_enum_1.AwarenessChannel.ETC]: '기타',
};
exports.PRE_REGISTRATION_AWARENESS_CHANNELS = [
    marketing_enum_1.AwarenessChannel.MASS_MEDIA,
    marketing_enum_1.AwarenessChannel.SNS,
    marketing_enum_1.AwarenessChannel.OFFLINE_AD,
    marketing_enum_1.AwarenessChannel.PORTAL_SEARCH,
    marketing_enum_1.AwarenessChannel.REFERRAL,
];
